import { render, staticRenderFns } from "./budgetCustomization.vue?vue&type=template&id=fade70f4&scoped=true&"
import script from "./budgetCustomization.vue?vue&type=script&lang=js&"
export * from "./budgetCustomization.vue?vue&type=script&lang=js&"
import style0 from "./budgetCustomization.vue?vue&type=style&index=0&id=fade70f4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fade70f4",
  null
  
)

export default component.exports